import React from 'react';
import { MobileNavBar, MobileNavBarProps } from '@components/MobileNavBar/MobileNavBar';
import NavBar from '@components/NavBar';
import { useViewport } from '@hooks/viewport';

export type HeaderProps = {
  landing?: boolean;
  mobileNavBarProps?: MobileNavBarProps;
};

const Header: React.FC<HeaderProps> = (props) => {
  const { landing, mobileNavBarProps } = props;
  const { isMobile } = useViewport();

  if (isMobile) {
    return <MobileNavBar {...mobileNavBarProps} />;
  }

  return <NavBar landing={landing} />;
};

export default Header;
